/*
 * @Author: Suroc
 * @Date: 2024-08-14 10:08:36
 * @LastEditTime: 2024-08-14 10:08:42
 * @Description: 
 */
import { createPinia } from "pinia";
const pinia = createPinia();
export default pinia;